import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';

import { serializeToQuery } from '../lib/serialize';
import { $, $$ } from '../lib/selectors';

function loadScript(url) {
  let scriptEl = document.createElement('script');
  scriptEl.src = url;
  document.body.appendChild(scriptEl);
}

function queryParam(key) {
  const match = (new RegExp('[?&]' + key + '=([^&]+)')).exec(location.search);
  return match ? match[1] : null;
}

function initAction(actionEl) {
  const step1El = $(actionEl, '.js-action__step1');
  const step2El = $(actionEl, '.js-action__step2');

  let privacyCountries = [];

  // Load ActionKit context
  // Adapted from https://act.thesyriacampaign.org/resources/actionkit.js

  function addHiddenField(name, value) {
    if (value) {
      let inputEl = document.createElement('input');
      inputEl.type = 'hidden';
      inputEl.name = name;
      inputEl.value = value;
      actionEl.appendChild(inputEl);
    }
  }

  window.contextCallback = function (context) {
    privacyCountries = context.privacy_record_countries;

    const referringAkid = context.name && queryParam('akid') || context.referring_akid;
    addHiddenField('referring_akid', referringAkid);
    addHiddenField('aktmid', queryParam('aktmid'));
    addHiddenField('source', queryParam('source'));

    if (context.recaptcha_site_key) {
      $(actionEl, '.g-recaptcha').setAttribute('data-sitekey', context.recaptcha_site_key);
      loadScript('https://www.google.com/recaptcha/api.js');
    }

    loadScript(`https://act.truthafterisis.org/progress/?page=${actionEl.elements.page.value}&callback=progressCallback`);
  };

  window.progressCallback = function (progress) {
    const totalEl = $('.js-progress-total');
    const goalEl = $('.js-progress-goal');
    totalEl.textContent = totalEl.getAttribute('data-supporters').replace('{}', progress.total.actions.toLocaleString());
    goalEl.textContent = goalEl.getAttribute('data-goal').replace('{}', progress.goal.toLocaleString());
    $('.js-progress-bar').style.width = (Math.min(1, progress.total.actions / progress.goal) * 100) + '%';
  }

  const contextArgs = '?callback=contextCallback&r=' + Math.random() +
    (location.search ? '&' + location.search.substr(1) : '');
  loadScript(`https://act.truthafterisis.org/context/${actionEl.elements.page.value}${contextArgs}`);

  // Submit form with JSONP

  actionEl.noValidate = true; // Let form be "submitted" to reveal more fields

  actionEl.addEventListener('submit', evt => {
    evt.preventDefault();
    if (actionEl.noValidate) {
      actionEl.noValidate = false;
      step2El.classList.remove('hidden-js');
      step1El.classList.add('hidden-js');
      $('.grecaptcha-badge').style.visibility = 'visible';
    } else {
      if (window.grecaptcha) {
        grecaptcha.reset();
        grecaptcha.execute();
      } else {
        window.submitCallback();
      }
      actionEl.classList.add('is-submitting');
    }
  });

  window.submitCallback = function () {
    loadScript(`${actionEl.action}?callback=actionCallback&${serializeToQuery(actionEl)}`);
  };

  window.actionCallback = function (resp) {
    actionEl.classList.remove('is-submitting');
    actionEl.classList.add(resp.result === 'success' ? 'is-thanks' : 'is-failed');
  };

  // Privacy stuff

  const countryEl = actionEl.elements.country;
  const privacyEl = $(actionEl, '.js-action__privacy');
  const privacyOptYesEl = actionEl.elements.opt_in[0];
  const privacyOptNoEl = actionEl.elements.opt_in[1];
  const privacyOptOutEl = $(actionEl, '.js-action__privacy-opt-out');

  function updatePrivacyUI() {
    const selectedCountry = countryEl.options[countryEl.selectedIndex].value;
    const needsPrivacy = privacyCountries.indexOf(selectedCountry) > -1;

    privacyEl.disabled = !needsPrivacy;
    privacyOptOutEl.classList[privacyOptNoEl.checked ? 'remove' : 'add']('hidden');
  }

  privacyOptYesEl.addEventListener('change', updatePrivacyUI);
  privacyOptNoEl.addEventListener('change', updatePrivacyUI);
  countryEl.addEventListener('change', updatePrivacyUI);
  updatePrivacyUI();
}

export default function init() {
  const actionEl = $('.js-action');
  const actionToggleEl = $('.js-action-toggle');

  if (actionEl) {
    initAction(actionEl);

    actionToggleEl.addEventListener('change', function () {
      if (actionToggleEl.checked) {
        disableBodyScroll();
      } else {
        enableBodyScroll();
      }
    });
    if (actionToggleEl.checked) {
      disableBodyScroll();
    }
  }
}
